import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { ProvedorSessao } from '@shared/auth/sessao';
import { queryClient } from '@shared/lib/query';
import { router } from './routes/router';
import { recarregarParaNovaVersao } from '@shared/lib/novaVersao';
import '@shared/styles/tokens.css';
import '@shared/styles/base.css';

// Um módulo do app não carregou: quase sempre é a aba aberta antes de um
// deploy pedindo um arquivo que já foi trocado. O Vite avisa por este
// evento em toda importação sob demanda (ver lib/novaVersao.ts).
window.addEventListener('vite:preloadError', () => {
  recarregarParaNovaVersao();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ProvedorSessao>
        <RouterProvider router={router} />
      </ProvedorSessao>
    </QueryClientProvider>
  </StrictMode>,
);
